import { PrimaryButton } from "@/Components/v2/atoms/Button";
import { Typography } from "@/Components/v2/atoms/Typography";
import FullScreenCentered from "@/Components/v2/template/FullScreenCentered";
import { useLogout } from "@/hooks/useLogout";

const AccessDeniedPage = ({ error }: { error?: any }) => {
  const { logout } = useLogout();
  if (error) {
    const errorData = error.response.data;
    if (
      errorData.message === "ClickHouse authentication failed" ||
      errorData.message === "No timeline id found"
    ) {
      return (
        <FullScreenCentered>
          <Typography fontWeight={600} variant="h4">
            This page is unavailable due to no model data.
          </Typography>
          <Typography maxWidth={"490px"} textAlign="center">
            There is no data for this customer. If you expect there to be data, please contact{" "}
            <a href="mailto:support@mutinex.co">support@mutinex.co</a>.
          </Typography>
          <PrimaryButton onClick={() => logout()}>Log Out</PrimaryButton>
        </FullScreenCentered>
      );
    }
  }
  return (
    <FullScreenCentered>
      <Typography fontWeight={600} variant="h4">
        This page is unavailable
      </Typography>
      <Typography maxWidth={"490px"} textAlign="center">
        You may not have permission view this page. If you believe you should have access, please
        contact <a href="mailto:support@mutinex.co">support@mutinex.co</a>.
      </Typography>
      <PrimaryButton onClick={() => logout()}>Log Out</PrimaryButton>
    </FullScreenCentered>
  );
};

export default AccessDeniedPage;
